import { useEffect, useState } from "react";
import WOW from 'wowjs';
import Header from "../components/Header";
import Footer from "../components/Footer";

import peticionfamiliar from '../../../assets/img/peticion-familiar.png';

const PeticionesFamiliaresPage = () => {

    const [open, setOpen] = useState(false);
    const [visible, setVisible] = useState(true);

    const openModal = () => setOpen(true);
    const closeModal = () => setOpen(false);

    useEffect(() => {
        new WOW.WOW().init();
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const handleClick = ({
        phone = "16892589039",
        message = "Hola, quiero más información",
    }) => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;

        const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

        // URL de WhatsApp
        const whatsappURL = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}&app_absent=0`;

        // En iOS Safari, abrir directamente
        if (isIOS) {
            window.location.href = whatsappURL;
        } else {
            window.open(whatsappURL, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <>
            <Header currentSection='peticiones-familiares' />
            <section id='peticiones-familiares' className="peticiones-familiares w-100 pt-130" style={{ background: "linear-gradient(rgba(249, 249, 249, 1), rgba(249, 249, 249, 1))" }}>
                <div className='container d-flex flex-column justify-content-center align-items-center'>
                    <div className="info-card">

                        <div className="banner">
                            <img src={peticionfamiliar} alt="Solicitud de asilo" className="banner-img" />
                            <div className="overlay"></div>

                            <div className="banner-text">
                                <h2>¿Qué es la Petición Familiar?</h2>
                                <p>Asilo a tu Alcance te guia paso a paso para que puedas realizar tu petición familiar</p>
                                <button className="btn-ver-video d-flex justify-content-center align-items-center" onClick={openModal}>
                                    Ver video
                                    <span className="bi bi-play fs-3"></span>
                                </button>
                            </div>
                        </div>

                        {/* <h2 className="info-card__title fw-bold">¿Qué es la Petición Familiar?</h2> */}
                        <p className="info-card__text mt-3">
                            La Petición Familiar es el proceso legal clave para que un ciudadano estadounidense (USC) o Residente Permanente (LPR) solicite que un familiar obtenga una visa de inmigrante y pueda vivir de forma permanente en los Estados Unidos. Es la vía principal para la reunificación familiar.
                        </p>

                        <h3 className="info-card__subtitle">Requisitos y Elegibilidad del Patrocinador</h3>
                        <p className="info-card__text">
                            Para iniciar el proceso, debes ser Ciudadano Estadounidense o Residente Permanente Legal. Es fundamental:
                        </p>
                        <ul className="info-card__list">
                            <li>Demostrar una relación familiar aprobada (cónyuges, hijos, padres, hermanos).</li>
                            <li>Probar la autenticidad de la relación.</li>
                            <li>Comprometerte como patrocinador financiero y demostrar ingresos suficientes (solvencia) y cumplimiento de impuestos.</li>
                        </ul>

                        <h3 className="info-card__subtitle">Categorías de Familiares</h3>
                        <p className="info-card__text">La prioridad de tu caso depende de la relación:</p>
                        <p className="info-card__text">
                            <strong>1. Familiares Inmediatos: </strong> Están exentos de cuotas y tienen un proceso más rápido. Incluyen cónyuges, hijos solteros menores de 21 años y padres de ciudadanos estadounidenses.
                        </p>
                        <p className="info-card__text">
                            <strong>2. Familiares de Preferencia: </strong> Están sujetos a límites numéricos de visa y suelen tener tiempos de espera más largos (hijos mayores, hermanos, cónyuges e hijos de residentes permanentes).
                        </p>

                        <h3 className="info-card__subtitle">Beneficios Clave de la Residencia</h3>
                        <p className="info-card__text">
                            Obtener la residencia permanente a través de este proceso te permite:
                        </p>
                        <ul className="info-card__list">
                            <li>Reunirte con tus seres queridos en EE. UU</li>
                            <li>Gozar de libertad laboral sin visas de trabajo adicionales.</li>
                            <li>Tener movilidad internacional.</li>
                            <li>Acceder a beneficios sociales y educativos.</li>
                            <li>Iniciar el camino hacia la Ciudadanía estadounidense.</li>
                        </ul>

                        <h3 className="info-card__subtitle">Proceso a Seguir</h3>
                        <p className="info-card__text">
                            El proceso se inicia con la presentación del Formulario I-130 ante el USCIS, junto con toda la documentación de soporte. Tras la aprobación, el siguiente paso es el Ajuste de Estatus (si el familiar está en EE. UU.) o el Procesamiento Consular (si está fuera).
                        </p>
                        <p className="info-card__text">
                            Los tiempos son variables, siendo más rápidos para Familiares Inmediatos y más largos para las categorías de Preferencia.
                        </p>
                        <h3 className="info-card__subtitle">¿Qué pasa cuando la petición familiar es denegada?</h3>
                        <p className="info-card__text">
                            Si tu petición es denegada, recibirás una notificación detallada con los motivos. Siempre es recomendable analizar las razones, corregir los errores y, en muchos casos, volver a presentar la petición o considerar una apelación con la ayuda de nuestros asesores expertos.
                        </p>
                    </div>
                    <button onClick={handleClick} className="border-0 text-white text-decoration-none px-3 py-3 rounded-4 text-center wow bounce z-1 bg-secondary" style={{ fontSize: '1.1rem' }}>
                        <i className="bi bi-whatsapp"></i> Habla con un asesor
                    </button>
                    <div className='mb-5'></div>
                </div>
            </section>
            {open && (
                <div className="modal-video" onClick={closeModal}>
                    <div
                        className="modal-video-content"
                        onClick={(e) => e.stopPropagation()} // evita cerrar al hacer clic dentro
                    >
                        <span className="cerrar" onClick={closeModal}>
                            &times;
                        </span>
                        <iframe
                            width="315"
                            height="560"
                            src="https://www.youtube.com/embed/RgP-W113O6A?autoplay=1"
                            title="Video de YouTube"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            )}
            <Footer />
            <div className="chat-container">
                {visible && (
                    <div className="chat-popup">
                        <div className="chat-text">
                            <strong>Asilo a tu Alcance</strong><br />
                            ¡Hola! Soy tu asesor de Inmigración. ¿Cómo te puedo ayudar?
                        </div>
                        <span className="close-btn" onClick={() => setVisible(false)}>×</span>
                    </div>
                )}
                <div className="chat-icon">
                    <button onClick={handleClick} className="border-0 btn-wsp d-flex align-items-center justify-content-center">
                        <i className="bi bi-whatsapp icono"></i>
                    </button>
                </div>
            </div>
        </>
    );
}

export default PeticionesFamiliaresPage;